export default "__VITE_ASSET__CtXnokJL__"